// removed by extract-text-webpack-plugin
module.exports = {"OutboundSendFrom":"OutboundSendFrom---ga98w"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/playbook/components/WelcomeMessage/style.styl
// module id = 2FY8
// module chunks = 89